export default __webpack_public_path__ + "static/media/mic_rec.283182b9.png";